import { render, staticRenderFns } from "./BookmarkOutline.vue?vue&type=template&id=56902a6e"
import script from "./BookmarkOutline.vue?vue&type=script&lang=js"
export * from "./BookmarkOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports